/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { MarkerParticipantOut } from './markerParticipantOut';

/**
 * The reserved point lane. Nothing writes a point marker, so `MarkersOut.points` is
 * always empty; the shape exists so the lane can be filled without a contract change.
 * `kind` is open because there is no point kind to enumerate yet.
 */
export interface MarkerPointOut {
  kind: string;
  at_ms: number;
  participant: MarkerParticipantOut | null;
}
